import operationalDataFromJson from "../operational/mapper";
import PositionData from "./data";

export default function positionDataFromJson(json) {
    return new PositionData(
        json.position,
        json.latitude,
        json.longitude,
        json.speed ? json.speed : 0,
        json.direction ? json.direction : 0,
        json.geometry,
        json.etd,
        json.timestamp,
        operationalDataFromJson(json.operational)

    )
}